import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Fade } from "@mui/material";

import PromptProperties from "./components/PromptProperties";
import PromptArea from "./components/PromptArea";
import CustomTableV2 from "../../common/CustomTableV2";

import { GetPrompts } from "../../redux/prompt/actions";
import { GetAllIndiPrograms } from "../../redux/program/actions";
import { weeks } from "../../constants";

import "./style.css";

function OnboardingPromptPlayground(props) {
    const [properties, setProperties] = useState(null);
    const [prompts, setPrompts] = useState(null);
    const [activePrompt, setActivePrompt] = useState(0);
    const [results, setResults] = useState([]);


    useEffect(async () => {
        props.GetAllIndiPrograms();
        const res = await props.GetPrompts(1, 5, { prompt_group: "onboarding" }, null, true);

        let tempProps = [];
        res?.map((prompt) => {
            tempProps = [...tempProps, ...JSON.parse(prompt.props)];
        });

        setProperties(tempProps);
        setPrompts(res?.reverse());
    }, []);


    const finalResult = results[2];

    return (
        <div id="onboarding-prompt-playground" className="main-container">
            <Fade in={true}>
                <div>
                    <h5>Onboarding Prompt Playground</h5>

                    <div id="opp-content">
                        <div>
                            <div className="opp-c-card">
                                <div className="opp-c-c-header">
                                    <h6>Properties</h6>
                                </div>

                                <div className="opp-c-c-body">
                                    <PromptProperties properties={properties} setProperties={setProperties} />
                                </div>
                            </div>
                        </div>

                        <div>
                            <div className="opp-c-card">
                                <div className="opp-c-c-header">
                                    <h6>Prompt</h6>
                                </div>

                                <div className={`opp-c-c-body ${activePrompt != 0 ? "opp-c-c-b-hidden" : ""}`}>
                                    <PromptArea prompts={prompts} setPrompts={setPrompts} prompt={prompts?.[0]} properties={properties} setProperties={setProperties} setActivePrompt={setActivePrompt} activePrompt={activePrompt} results={results} setResults={setResults} />
                                </div>
                                <div className={`opp-c-c-body ${activePrompt != 1 ? "opp-c-c-b-hidden" : ""}`}>
                                    <PromptArea prompts={prompts} setPrompts={setPrompts} prompt={prompts?.[1]} properties={properties} setProperties={setProperties} setActivePrompt={setActivePrompt} activePrompt={activePrompt} results={results} setResults={setResults} />
                                </div>
                                <div className={`opp-c-c-body ${activePrompt != 2 ? "opp-c-c-b-hidden" : ""}`}>
                                    <PromptArea prompts={prompts} setPrompts={setPrompts} prompt={prompts?.[2]} properties={properties} setProperties={setProperties} setActivePrompt={setActivePrompt} activePrompt={activePrompt} results={results} setResults={setResults} />
                                </div>
                            </div>

                            {
                                finalResult && <div className="opp-c-card">
                                    <div className="opp-c-c-header">
                                        <h6>Result</h6>
                                    </div>
                                    <div className="opp-c-c-body">
                                        {
                                            finalResult && finalResult?.map(fr => {
                                                return (
                                                    <div className="opp-c-c-b-final-result">
                                                        <CustomTableV2
                                                            title={`Week ${fr?.weekNo}`}
                                                            description=""
                                                            store={{
                                                                list: fr?.days,
                                                                count: fr?.days?.length,
                                                            }}
                                                            table={{
                                                                headers: [

                                                                    { title: "Day" },
                                                                    { title: "Program" },
                                                                    { title: "Duration" },
                                                                ],
                                                                body: (data, i) => {
                                                                    let rps = [...data?.recommendedPrograms];

                                                                    rps.shift();

                                                                    // if (rps?.length > 1) {
                                                                    // }

                                                                    return (
                                                                        <>
                                                                            <tr className={i % 2 == 0 ? "tr-even" : ""}>
                                                                                <td><h5>{weeks[(data?.day * 1) + 1]}</h5></td>
                                                                                <td><h5>{data?.recommendedPrograms[0]?.program}</h5></td>
                                                                                <td><h5>{data?.recommendedPrograms[0]?.min}</h5></td>
                                                                            </tr>
                                                                            {
                                                                                rps?.map((rp, i2) => {
                                                                                    return (
                                                                                        <tr className={(i + i2) % 2 == 0 ? "tr-even" : ""}>
                                                                                            <td><h5></h5></td>
                                                                                            <td><h5>{rp?.program}</h5></td>
                                                                                            <td><h5>{rp?.min}</h5></td>
                                                                                        </tr>
                                                                                    )
                                                                                })

                                                                            }

                                                                        </>
                                                                    )
                                                                }
                                                            }}
                                                            actions={{
                                                            }}
                                                            withPagination={false}
                                                            withSearch={false}
                                                            defaultPerPage={100}
                                                        />
                                                    </div>

                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            }
                            {/* 
                            {
                                finalResult && <div className="opp-c-card">
                                    <div className="opp-c-c-header">
                                        <h6>Result</h6>
                                    </div>
                                    <div className="opp-c-c-body">
                                        {
                                            finalResult && finalResult?.map((fr, i) => {
                                                return (
                                                    <div className="opp-c-c-b-final-result">
                                                        <CustomTableV2
                                                            title={`Week ${i + 1}`}
                                                            description=""
                                                            store={{
                                                                list: fr?.days,
                                                                count: fr?.days?.length,
                                                            }}
                                                            table={{
                                                                headers: [

                                                                    { title: "Day" },
                                                                    { title: "Duration" },
                                                                ],
                                                                body: (data, i) => {

                                                                    return (
                                                                        <tr className={i % 2 == 0 ? "tr-even" : ""}>
                                                                            <td><h5>{weeks[(data?.day * 1) + 1]}</h5></td>
                                                                            <td><h5>{data?.min}</h5></td>
                                                                        </tr>
                                                                    )
                                                                }
                                                            }}
                                                            actions={{
                                                            }}
                                                            withPagination={false}
                                                            withSearch={false}
                                                            defaultPerPage={100}
                                                        />
                                                    </div>

                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            } */}


                        </div>
                    </div>
                </div>

            </Fade>
        </div>
    );
}

const mapStateToProps = (state) => ({
})

export default connect(mapStateToProps, {
    GetPrompts,
    GetAllIndiPrograms,
})(OnboardingPromptPlayground);
